<template>
  <div>
    <b-label label="Підроздід / Підрозділи перевірки"></b-label>
    <div class="d-flex ga-3 align-center object-block">
      <v-chip
        v-for="objectDepartment in objectDepartments"
        :key="objectDepartment.id"
        border
        closable
        color="blue-darken-3"
        density="compact"
        rounded="lg"
        @click:close="deleteObjectDepartment(objectDepartment.id)">
        {{ objectDepartment.internal_department.name }}
      </v-chip>
      <span v-if="!objectDepartments.length" class="text-disabled">
        Не вказано
      </span>
      <v-dialog v-model="dialog" width="400">
        <template #activator="{ props }">
          <v-btn
            border="dashed thin"
            color="blue-darken-3"
            rounded="lg"
            size="small"
            v-bind="props"
            variant="text">
            <div
              class="d-flex align-center ga-1 font-weight-medium text-blue-darken-3">
              <v-icon color="blue-darken-3" icon="mdi-plus"></v-icon>
              <span>Додати</span>
            </div>
          </v-btn>
        </template>

        <dialog-template
          dialog-width="480px"
          hide-action-buttons
          subtitle="Оберіть один або декілька підрозділів з довідника"
          title="Підрозділи перевірки"
          @close="dialog = false">
          <b-input
            v-model="searchStr"
            hide-details
            placeholder="Пошук підрозділу">
            <template #prepend-inner>
              <v-icon icon="mdi-magnify" size="small"></v-icon>
            </template>
          </b-input>

          <div
            class="d-flex flex-column ga-2 overflow-y-auto mt-3"
            style="max-height: 500px">
            <v-card
              v-for="department in filteredDepartments"
              :key="department.id"
              :class="{
                'selected-department': objectDepartments.some(
                  d => d.internalDepartmentId === department.id
                ),
              }"
              :disabled="
                $loading.isLoading([
                  `createObjectDepartment_${department.id}`,
                  `deleteObjectDepartment_${department.id}`,
                ])
              "
              :loading="
                $loading.isLoading([
                  `createObjectDepartment_${department.id}`,
                  `deleteObjectDepartment_${department.id}`,
                ])
              "
              border>
              <v-card-text class="pa-1">
                <v-checkbox
                  :label="department.name"
                  :model-value="
                    objectDepartments.some(
                      d => d.internalDepartmentId === department.id
                    )
                  "
                  class="w-100"
                  color="blue-darken-3"
                  hide-details
                  @update:model-value="
                    $event
                      ? createObjectDepartment(department.id)
                      : (() => {
                          const item = objectDepartments.find(
                            d => d.internalDepartmentId === department.id
                          )
                          if (item) deleteObjectDepartment(item.id)
                        })()
                  ">
                </v-checkbox>
              </v-card-text>
            </v-card>

            <div
              v-if="!filteredDepartments.length"
              class="text-disabled text-center py-5">
              Дані відсутні
            </div>
          </div>

          <div class="d-flex justify-end mt-5">
            <v-btn
              border
              color="white"
              density="comfortable"
              @click="dialog = false">
              Готово
            </v-btn>
          </div>
        </dialog-template>
      </v-dialog>
    </div>
  </div>
</template>

<script lang="ts">
import { useAudit } from '../../index'
import { BLabel } from 'best-modules/components'
import DialogTemplate from '@/dialog/DialogTemplate.vue'
import { computed, ref, watch } from 'vue'
import { fillDirectory, getDirectory } from '@/directory'

export default {
  name: 'ObjectDepartments',
  components: { DialogTemplate, BLabel },
  setup() {
    const {
      objectDepartments,
      createObjectDepartment,
      deleteObjectDepartment,
    } = useAudit()
    const dialog = ref<boolean>(false)
    const searchStr = ref<string | null>(null)

    const filteredDepartments = computed(() => {
      const departments = getDirectory('internalDepartments') || []

      if (!searchStr.value) return departments

      return departments.filter(department =>
        department.name.toLowerCase().includes(searchStr.value!.toLowerCase())
      )
    })

    watch(
      () => dialog.value,
      val => {
        if (val) {
          fillDirectory('internalDepartments')
        }
      }
    )

    return {
      objectDepartments,
      createObjectDepartment,
      deleteObjectDepartment,
      filteredDepartments,
      searchStr,
      dialog,
    }
  },
}
</script>

<style lang="scss" scoped>
.object-block {
  padding: 3px 13px;
  background: #f5f6fa;
  border-radius: 9px;
  border: 1px solid #f0f0f5;
  color: #1a1a1b;
  min-height: 40px;
  max-height: 40px;

  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
:deep(.v-checkbox .v-selection-control) {
  min-height: 25px !important;
}
.selected-department {
  background: rgba(25, 118, 210, 0.12);
  border: 1px solid rgb(25, 118, 210);

  :deep(.v-checkbox .v-label) {
    color: rgb(25, 118, 210);
    font-weight: 700;
  }
}
</style>
